module.exports = __webpack_public_path__ + "img/PU30M_1.36d162f4.png";